// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__JwEOA","footer":"ModalFilter_footer__9WWUS"};